import { useParameterizedAsyncData } from "src/utils/async/parameterizedAsyncData.ts";
import { SitePartRevisionBomTreeViewApi } from "src/api/generated/erp/parts/sitePart/api/bom/sitePartRevisionBomTreeViewApi.ts";
import { AsyncRender } from "src/components/common/async/AsyncRender.tsx";
import { PartRevisionBomTreeItemModel } from "src/components/views/erp/parts/treeViews/treeItemMapping.ts";
import { SitePartRevisionBomTreeViewResult } from "src/api/generated/erp/parts/sitePart/api/bom/sitePartRevisionBomTreeViewResult.ts";
import { PartRevisionBomTreeViewBase } from "src/components/views/erp/parts/treeViews/PartRevisionBomTreeViewBase.tsx";

export interface SitePartRevisionBomTreeViewProps {
	partRevisionId: number;
	onSelectionChanged?: (selectedItem: PartRevisionBomTreeItemModel | null) => void;
}

export const SitePartRevisionBomTreeView = ({ partRevisionId, onSelectionChanged }: SitePartRevisionBomTreeViewProps) => {
	const { dataAsync, refresh, paramValues } = useParameterizedAsyncData<
		SitePartRevisionBomTreeViewResult,
		SitePartRevisionBomTreeViewParams
	>({
		fetchData: ({ searchQuery, showRevisions }) =>
			SitePartRevisionBomTreeViewApi.getTreeElements({
				partRevisionId: partRevisionId,
				searchQuery: searchQuery,
				showRevisions: showRevisions,
			}),
		initialParams: {
			searchQuery: "",
			showRevisions: false,
		},
	});

	return (
		<AsyncRender
			asyncData={dataAsync}
			reloadOnError={() => refresh()}
			content={(data) => (
				<PartRevisionBomTreeViewBase
					treeElements={data.treeElements}
					showRevisions={paramValues.showRevisions}
					onSearchQueryChange={(searchQuery) => refresh({ searchQuery })}
					onShowRevisionsChange={(showRevisions) => refresh({ showRevisions })}
					onSelectionChanged={onSelectionChanged}
				/>
			)}
		/>
	);
};

interface SitePartRevisionBomTreeViewParams {
	searchQuery: string;
	showRevisions: boolean;
}

